import type { FC } from "react";
import { useEffect } from "react";
import { AnalyticsListTypes } from "@lib/analytics/analyticsTypes";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { ProductHitsWrapper } from "./ProductHitsWrapper";
import dynamic from "next/dynamic";
import { useNormalizedInfiniteHits } from "@hooks/useNormalizedInfiniteHits";
import type { IPartStoryTile } from "@contentful-api/types/contentful";

import { useFilterStore } from "@store/filterStore";
import { keyframes } from "@emotion/react";
import { Box } from "@ecco/ui/box";
import { transitions } from "@ecco/ui/tokens";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const ProductListFooter = dynamic(
    () => import("@components/commerce/product/list/product-list-footer/ProductListFooter"),
    { ssr: false }
);

interface IProductListProps {
    widgetSize?: string;
    editorialWidgets?: IPartStoryTile[];
}

export const ProductList: FC<IProductListProps> = ({ widgetSize, editorialWidgets }) => {
    const { get: getMicrocopy } = useMicrocopy();
    const noResults = getMicrocopy("page", "PLP.summary.noResults");

    const { currentPageHits, numberOfHits } = useNormalizedInfiniteHits();

    const setFilterStoreResultsCount = useFilterStore((state) => state.setResultCount);

    useEffect(() => {
        setFilterStoreResultsCount(numberOfHits);
    }, [numberOfHits]);

    return (
        <Box
            animation={`${fadeIn} ${transitions.duration.slow} ${transitions.easing["ease-in-out"]}`}
        >
            <ProductHitsWrapper
                productListHits={currentPageHits}
                footerContent={<ProductListFooter />}
                noResultsContent={noResults}
                shouldSaveLastVisitedPath={true}
                productListName={AnalyticsListTypes.plp}
                widgetSize={widgetSize}
                editorialWidgets={editorialWidgets}
            />
        </Box>
    );
};
